import React from "react";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { FormInput, FormTextArea, FormCheckbox } from "../FormComponents";
import { requiredValidator, urlValidator } from "../Validators";

interface AddLinkFormProps {
  onSubmit: (dataItem: any) => void;
  onCancel?: () => void;
}

const AddLinkForm = ({ onSubmit, onCancel }: AddLinkFormProps) => {
  const handleSubmit = (dataItem: any) => {
    // Format data for API
    const linkData = {
      name: dataItem.name,
      description: dataItem.description || "",
      url: dataItem.url,
      enabled: dataItem.enabled !== undefined ? dataItem.enabled : true,
    };
    onSubmit(linkData);
  };

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={{
        name: "",
        description: "",
        url: "",
        enabled: true,
      }}
      render={(formRenderProps) => (
        <FormElement style={{ padding: "1rem", marginBottom: "5rem" }}>
          <fieldset className={"k-form-fieldset"}>
            <div className="form__subtitle">
              Add link details:
              <button
                className="form__reset__button"
                type="button"
                onClick={formRenderProps.onFormReset}
              >
                Clear fields
              </button>
            </div>

            <Field
              name={"name"}
              component={FormInput}
              label={"Name: "}
              placeholder={"Enter link name"}
              validator={requiredValidator}
            />

            <Field
              name={"description"}
              component={FormTextArea}
              label={"Description: "}
              placeholder={"Enter description"}
            />

            <Field
              name={"url"}
              component={FormInput}
              label={"URL: "}
              placeholder={"https://example.com"}
              validator={urlValidator}
            />

            <Field
              name={"enabled"}
              component={FormCheckbox}
              label={"Enabled"}
            />
          </fieldset>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "1rem",
              bottom: 0,
              left: 0,
              width: "100%",
              padding: "1rem 2rem 1rem 2rem",
              position: "absolute",
              zIndex: "10000",
              backgroundColor: "#fff",
              borderTop: "1px solid #edebe9",
            }}
          >
            <button
              type={"submit"}
              disabled={!formRenderProps.allowSubmit}
              className="form__submit-button"
              style={{
                width: "100%",
                marginTop: "0.5rem",
              }}
            >
              Add Link
            </button>
            {onCancel && (
              <button
                type="button"
                onClick={onCancel}
                className="form__cancel-button"
                style={{
                  width: "100%",
                  marginTop: "0.5rem",
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </FormElement>
      )}
    />
  );
};

export default AddLinkForm;
